export enum FooterDataTestIdEnum {
  FOOTER_FOR_YOU_SECTION = 'for-you-section',
  FOOTER_FOR_PROFESSIONALS_AND_CLINICS_SECTION = 'for-professionals-and-clinics-section',
  FOOTER_DOWNLOAD_APP_SECTION = 'download-app-section',
  FOOTER_ABOUT_SECTION = 'about-section',
  FOOTER_INSTAGRAM_LINK = 'instagram-link',
  FOOTER_FACEBOOK_LINK = 'facebook-link',
  FOOTER_RESERVED = 'reserved-footer',
  FOOTER_CONTENT = 'footer-content',
  FOOTER_PAYMENT_INFO = 'payment-info',
  FOOTER_IOS_LINK = 'ios-link',
  FOOTER_ANDROID_LINK = 'android-link',
  FOOTER_MOCK_ITEM = 'mock-item',
  FOOTER_MOCK_ITEM_LIST = 'mock-item-list',
  FOOTER_MOCK_BLAME_HERE = 'mock-blame-here',
  FOOTER_MOCK_DOWNLOAD_APP = 'mock-download-app',
  FOOTER_MOCK_OUR_NETWORK = 'mock-our-network',
  FOOTER_MOCK_ACCORDION = 'mock-accordion',
  FOOTER_MOCK_ITEM_TITLE = 'mock-footer-item-title',
  FOOTER_MOCK_IMAGE = 'mock-image',
}
